
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo: { title: 'Início' },

    extends: View,

    mixins: [
      LoadSections([
        'theme-features-pro',
        'contact-us',
        // 'pro-features',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'features-view',
      },
    },
  }
</script>
